import {getCountries, getCountryCallingCode, parsePhoneNumberFromString} from 'libphonenumber-js/min';

export function phoneCountries(locale = 'tr') {
  let names;
  try { names = new Intl.DisplayNames([locale], {type: 'region'}); } catch { names = null; }
  return getCountries().map(country => ({country, name: names?.of(country) || country, code: '+' + getCountryCallingCode(country)}))
    .sort((a, b) => a.name.localeCompare(b.name, locale));
}

export function internationalPhone(value, country) {
  const input = value.trim().replace(/^00/, '+');
  // Reject prose, extensions and multiple numbers rather than extracting a recipient.
  if (!/^[+\d\s().-]+$/.test(input)) return null;
  const parsed = parsePhoneNumberFromString(input, country);
  return parsed?.isPossible() && !parsed.ext ? parsed : null;
}
